import * as React from "react";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";

export default class Swatch extends React.PureComponent {

  static propTypes = {
    "active": PropTypes.bool.isRequired,
    "fromClearance": PropTypes.bool.isRequired,
    "handleSwatchClick": PropTypes.func,
    "hidden": PropTypes.bool,
    "id": PropTypes.number.isRequired,
    "nav": PropTypes.bool,
    "productName": PropTypes.string,
    "storePath": PropTypes.string,
    "swatchName": PropTypes.string.isRequired,
    "url": PropTypes.string
  };

  static defaultProps = {
    "handleSwatchClick": null,
    "hidden": false,
    "nav": true,
    "productName": null,
    "storePath": "/jewelry",
    "url": null
  };

  handleClick = () => {
    const {handleSwatchClick, id, nav} = this.props;

    if (nav) {
      return;
    }

    handleSwatchClick(id);
  };

  render () {
    const {
      active,
      fromClearance,
      hidden,
      nav,
      productName,
      storePath,
      swatchName,
      url
    } = this.props;

    return (
      <div
        className={`${active && "active"} ${hidden
          ? "tmp-hidden"
          : "inline-block"}`}
        id="Swatch"
      >
        <div className="swatch-circle" />
        {(url && url === location.pathname) || !nav
          ? (
            <div
              className={`sprite-${swatchName.replace(/[ /]/g, "-")} sprite-swatch circle`}
              onClick={this.handleClick}
              title={productName || swatchName}
            />)
          : (
            <Link
              className="image-link"
              to={{
                "pathname": url,
                "state": {
                  "fromClearancePage": fromClearance,
                  "prevPath": storePath
                }
              }}
            >
              <div
                className={`sprite-${swatchName.replace(/[ /]/g, "-")} sprite-swatch circle`}
                title={productName || swatchName}
              />
            </Link>)}
        {!url &&
        <div
          className={`sprite-${swatchName.replace(/[ /]/g, "-")} sprite-swatch circle`}
          title={productName || swatchName}
        />}
      </div>
    );
  }
}
